import Http from '../utils/axios'
const rt = '/api-zendai/report'
const user = '/api-zendai/user'
const workflow = '/api-zendai/workflow'
const investment = '/api-zendai/investment'
export default {
    //获取列表
    getList(params){
        return Http.post(`${rt}/reportConfig/list`,params)
    },
    // 获取大区
    getAuthorityAllMallRegion(){
        return Http.get(`${investment}/e/mallManage/getAuthorityAllMallRegion?tierLevel=2`)
    },
    create(params){
        return Http.post(`${rt}/reportConfig/create`,params)
    },
    update(params){
        return Http.post(`${rt}/reportConfig/update`,params)
    },
    getMall(params){
        return Http.get(`${user}/v1/e/mall/getMallAuthoriHomePage`,params)
    },
    getReportData(id,params){
        return Http.post(`${rt}/report/${id}`,params)
    },
    getworkflowToMe(params){
        return Http.post(`${workflow}/e/flow/auditCenter/findFlowsRelatedToMe`,params)
    },
    getBuilding(params){
        return Http.get(`${investment}/e/mall/queryInvestMallDetailByCode`,params)
    }
}
